// Shared utility for LocationMapPanel and FastProperties prefetch.
// Both must use the IDENTICAL variable shape so Apollo caches the same key.

// Used by the property list query (includes spatial filters).
export function buildVars(filters) {
  return {
    cityId:          filters.cityId,
    neighborhoodIds: filters.neighborhoodIds?.length > 0
                       ? filters.neighborhoodIds.map(Number) : null,
    zipCodes:        filters.zipCodes?.length > 0 ? filters.zipCodes : null,
    minRent:         filters.minPrice  || null,
    maxRent:         filters.maxPrice  || null,
    bedroom:         filters.bedTypes?.length > 0 ? filters.bedTypes : null,
    bathroom:        filters.minBaths  ? [String(filters.minBaths)] : null,
    amenities:       filters.amenities?.length > 0 ? filters.amenities : null,
    policies:        filters.policies?.length  > 0 ? filters.policies  : null,
    availFrom:       filters.availFrom || null,
    onlyAvailable:   true,
  };
}

// Used for the GeoJSON map dots query — omits neighborhoodIds/zipCodes so the
// cache key covers ALL city properties and client-side filtering handles spatial.
export function buildMapVars(filters) {
  return {
    cityId:        filters.cityId,
    minRent:       filters.minPrice    || null,
    maxRent:       filters.maxPrice    || null,
    bedroom:       filters.bedTypes?.length > 0         ? filters.bedTypes         : null,
    bathroom:      filters.minBaths                     ? [String(filters.minBaths)] : null,
    // amenities → addons  (PROPERTIES_GEOJSON uses $addons/$excludeAddons)
    addons:        filters.amenities?.length > 0        ? filters.amenities        : null,
    excludeAddons: filters.excludeAmenities?.length > 0 ? filters.excludeAmenities : null,
    policies:      filters.policies?.length > 0         ? filters.policies         : null,
    availFrom:     filters.availFrom   || null,
    availTo:       filters.availTo     || null,
    // Numeric fields the query accepts as ValidString
    sqFeet:        filters.minSqft        ? String(filters.minSqft)        : null,
    escort:        filters.minEscort      ? String(filters.minEscort)      : null,
    sendEscort:    filters.minSend        ? String(filters.minSend)        : null,
    bonus:         filters.minBonus       ? String(filters.minBonus)       : null,
    yearFrom:      filters.builtAfter     ? String(filters.builtAfter)     : null,
    yearTo:        filters.builtBefore    ? String(filters.builtBefore)    : null,
    renovatedFrom: filters.renovatedAfter ? String(filters.renovatedAfter) : null,
    search:        filters.search         || null,
    onlyAvailable: filters.onlyAvailable !== false,
  };
}
